import { dashboardPrefix, etlPrefix, homePrefix, RouterProps } from "etl/types";
import { EtlTunnel } from "etl/page-etl-tunnel";
import { EtlHome } from "etl/page-home";
import { EtlDashboard } from "pages/dashboard";

export const APP_ROUTER: RouterProps[] = [
	{
		path: `${homePrefix}*`,
		component: <EtlHome />,
		protected: false,
		layout: true,
	},
	{
		path: `${etlPrefix}*`,
		component: <EtlTunnel />,
		protected: true,
		layout: true,
	},
	{
		path: `${dashboardPrefix}*`,
		component: <EtlDashboard />,
		protected: true,
		layout: true,
	}
] as const;
